export const translationOrganizations_en_part1 = {
  // Shared actions and labels
  add: "Add",
  attach: "Attach",
  attaching: "Attaching...",
  cancel: "Cancel",
  chatbotPlural: "chatbots",
  chatbotSingular: "chatbot",
  creating: "Creating...",
  currentlyUnassigned: "Currently unassigned",
  delete: "Delete",
  deleting: "Deleting...",
  detach: "Detach",
  detaching: "Detaching...",
  edit: "Edit",
  noDomainsConfigured: "No domains configured",
  remove: "Remove",
  resend: "Resend",
  save: "Save",
  saving: "Saving...",
  searchChatbotsPlaceholder: "Search chatbots…",
  searchOrganizationsPlaceholder: "Search organizations…",
  selectChatbotPlaceholder: "Select chatbot",
  selectOrganizationPlaceholder: "Select organization",
  unableToAttachChatbot: "Unable to attach chatbot.",
  unableToDetachChatbot: "Unable to detach chatbot.",
  unassigned: "Unassigned",
  // Organizations list page (index.tsx)
  // Organizations list page (index.tsx)
  orgsHeaderTitleAdmin: "Manage organizations and chatbots",
  orgsHeaderTitleOwner: "Manage organization access",
  orgsHeaderDescriptionAdmin:
    "Admins can create organizations, create or clone chatbot IDs, and control chatbot assignments across every org. Owners can manage members and invitations for the organizations they own.",
  orgsHeaderDescriptionOwner: "Manage members and invitations for the organizations you own.",
  orgsUnableToLoadOrganizations: "Unable to load organizations.",
  orgsOrganizationCreated: "Organization created.",
  orgsOrganizationDeleted: 'Organization "{name}" was deleted.',
  orgsUnableToCreateOrganization: "Unable to create organization.",
  orgsEyebrow: "Organizations",
  orgsTabOrganizations: "Organizations",
  orgsTabChatbots: "Chatbots",
  orgsSearchPlaceholder: "Search organizations, domains, or assigned chatbot IDs",
  orgsCreateOrganization: "Create Organization",
  orgsCreateDialogTitle: "Create organization",
  orgsCreateDialogDescription:
    "New organizations start without members or chatbots. You can invite owners and attach chatbots afterwards.",
  orgsOrganizationNameLabel: "Organization name",
  orgsOrganizationNamePlaceholder: "Acme Support",
  orgsDomainsLabel: "Domains",
  orgsDomainsPlaceholder: "acme.com, help.acme.com",
  orgsInviteRedirectUrlLabel: "Invite Redirect URL",
  orgsInviteRedirectUrlHelp:
    "Users who accept invitations or finish registration are sent here. Use an approved HTTPS dashboard URL.",
  orgsInviteRedirectUrlPlaceholder: "https://dashboard.askdiverge.ai",
  orgsCreate: "Create",
  orgsShowingCount: "Showing {shown} of {total} organizations",
  orgsForSearch: 'for "{search}"',
  orgsLoadingOrganizationsAria: "Loading organizations",
  orgsLoadingOrganizations: "Loading organizations...",
  orgsEmptyNoMatches: "No organizations matched your search.",
  orgsEmptyAdmin: "No organizations found yet. Create the first organization to get started.",
  orgsEmptyOwner: "No manageable organizations found.",
  orgsAdminAccess: "Admin access",
  orgsOwnerAccess: "Owner access",
  orgsMemberSingular: "Member",
  orgsMemberPlural: "Members",
  orgsOwnerSingular: "Owner",
  orgsOwnerPlural: "Owners",
  orgsInviteSingular: "Invite",
  orgsInvitePlural: "Invites",
  orgsAllOrganizationsLoaded: "All organizations loaded.",
  orgsLoadingMoreOrganizations: "Loading more organizations",
  // Chatbot management panel (ChatbotManagementPanel.tsx)
  // Chatbot management panel (ChatbotManagementPanel.tsx)
  botMgmtUnableToLoadChatbots: "Unable to load chatbots.",
  botMgmtChatbotCloned: "Chatbot cloned. It is currently unassigned.",
  botMgmtChatbotCreated: "Chatbot created. It is currently unassigned.",
  botMgmtUnableToCreateChatbot: "Unable to create chatbot.",
  botMgmtSelectOrgBeforeAttach: "Select an organization before attaching a chatbot.",
  botMgmtAttachedTo: "Attached {chatbotId} to {organizationName}.",
  botMgmtDetached: "Detached {chatbotId}.",
  botMgmtDetachChatbotTitle: "Detach {chatbotId}?",
  botMgmtDetachChatbotWarning:
    "The organization's members lose access to the chatbot. Its settings, AI conversations and contact forms stay; its livechat history and setup, Chatbot API forms, webhook events, agent test suites and workspaces, and store membership are deleted.",
  botMgmtDetachChatbotConfirm: "Detach chatbot",
  botMgmtDeleteChatbotTitle: "Delete chatbot {chatbotId}?",
  botMgmtDeleteChatbotWarning:
    "This permanently deletes the chatbot, including settings, conversations, and credentials. This cannot be undone.",
  botMgmtDeleteChatbotConfirm: "Delete chatbot",
  botMgmtChatbotDeleted: "Deleted {chatbotId}.",
  botMgmtUnableToDeleteChatbot: "Unable to delete chatbot.",
  botMgmtEyebrow: "Chatbots",
  botMgmtHeading: "Create, clone, and assign chatbot IDs",
  botMgmtIntro:
    "Create blank chatbots or clone an existing chatbot configuration. Each chatbot can be attached to only one organization at a time.",
  botMgmtStatTotal: "total",
  botMgmtStatUnassigned: "unassigned",
  botMgmtNewChatbotId: "New chatbot ID",
  botMgmtChatbotIdPlaceholder: "support-bot-eu",
  botMgmtCreationMode: "Creation mode",
  botMgmtSelectMode: "Select mode",
  botMgmtModeBlank: "Blank",
  botMgmtModeClone: "Clone existing",
  botMgmtSourceChatbot: "Source chatbot",
  botMgmtCreateHelper:
    "New chatbot IDs are created unassigned. Attach them to an organization below when needed.",
  botMgmtCreateChatbot: "Create Chatbot",
  botMgmtCatalogTitle: "Catalog",
  botMgmtCatalogDescription:
    "Unassigned chatbots can be attached to an organization. Assigned chatbots must be detached before they can move elsewhere.",
  botMgmtLoadingChatbotsAria: "Loading chatbots",
  botMgmtLoadingChatbots: "Loading chatbots...",
  botMgmtNoChatbotsFound: "No chatbots found yet.",
  botMgmtAssignedTo: "Assigned to {organization}",
  // Organization detail page (OrganizationDetail.tsx)
  // Organization detail page (OrganizationDetail.tsx)
  orgDetailTabMembers: "Members",
  orgDetailTabInvitations: "Invitations",
  orgDetailTabSettings: "Settings",
  orgDetailTabChatbots: "Chatbots",
  orgDetailTabBrands: "Brands",
  orgDetailTabBusiness: "Business",
  orgDetailBackToOrganizations: "Back to organizations",
  orgDetailLoadingOrganization: "Loading organization...",
  orgDetailAdminView: "Admin View",
  orgDetailOwnerView: "Owner View",
  orgDetailUnableToLoadOrganization: "Unable to load organization.",
};
